const Footer = (props) => {
  return (
      <div className={'text-center py-5 px-10 flex flex-wrap justify-center bg-nfr-color-100 dark:bg-nfr-color-900'}>
        {/*<p>
          Copyright (2021 - {new Date().getFullYear()}) @nahidferdous.com
        </p>*/}
        <p className={'pb-4'}>
          Designed and Developed by <span className={'text-amber-500'}>Nahid Ferdous</span>
        </p>
      </div>
  );
}

export default Footer;
